export default __webpack_public_path__ + "static/char-s-33-ja-53e6be14e3550d5474895229f3922a7a.png";